// React
import React, { useState, useEffect } from "react";

import "react-simple-flex-grid/lib/main.css";

// components
import { Button, Form, Tabs, Tab, InputGroup } from "react-bootstrap";
import EditableTagGroup from "./EditableTagGroup";
import EventCard from "../components/EventCard";
import ListTagsTypeahead from "../components/ListTagsTypeahead";

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";
import * as ModelCache from "../libs/ModelCache";
// ant design components
import { Collapse } from "antd";

const { Panel } = Collapse;

// DateTime
const { DateTime } = require("luxon");

function callback(key) {
  console.log(key);
}

export default function ListHomeContainer(props) {
  const [listContent, setListContent] = useState([]);
  const [filteredListContent, setFilteredListContent] = useState([]);
  const [focus, setFocus] = useState(false);
  const [tagsToList, setTagsToList] = useState({});
  const [membershipToList, setMembershipToList] = useState([]);
  const [allTagsAvailable, setAllTagsAvailable] = useState([]);
  const [tagMap, setTagMap] = useState({});
  const [selectedFilterTags, setSelectedFilterTags] = useState([]);

  const searchQueryInputRef = React.useRef();
  const listTagsTypeaheadRef = React.useRef();

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    loadLists();
    loadAllTags().then(allTags => {
      setAllTagsAvailable(allTags);
      var interim = {};
      for (var k = 0; k < allTags.length; k++) {
        const tag = allTags[k];
        interim[tag.raw] = tag;
      }
      setTagMap(interim);
    });
  }

  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone(
      "America/Los_Angeles"
    );
    const timeString = timeObject.toLocaleString(DateTime.DATE_MED);
    return <p>{timeString}</p>;
  }

  function loadLists() {
    if (props.email === null) {
      return;
    }
    EventifyAPI.fetchAllLists().then(
      result => {
        setListContent(result);
        setFilteredListContent(result);
      }
    );
  }

  function getMembershipCountFromListDataItem(listDataItem) {
    const membership = membershipToList[listDataItem.listid];
    var membershipCount = 0;
    if (membership != null && typeof membership.length !== "undefined") {
      membershipCount = membership.length;
    }
    return membershipCount;
  }

  function sortLists(data) {
    return data.sort((a, b) => {
      const aDate = a.primaryDate != null ? a.primaryDate : a.updated;
      const bDate = b.primaryDate != null ? b.primaryDate : b.updated;
      return aDate > bDate ? -1 : 1;
    });
  }

  function handleListFetch(data) {
    const sortedLists = sortLists(data);
    return (
      <>
        {sortedLists.map((listDataItem, i) => (
          <EventCard
            email={props.email}
            organizationid={props.organizationid}
            key={listDataItem.listid}
            list={listDataItem}
            tags={tagsToList[listDataItem.listid]}
            membershipCount={listDataItem.membershipCount}
          />
        ))}
      </>
    );
  }

  async function getTagsForList(listid) {
    if (props.email === null) {
      return;
    }
    const result = EventifyAPI.getTagsForList(
      listid
    );
    return result;
  }

  async function loadAllTags() {
    if (props.email === null) {
      return;
    }
    const result = EventifyAPI.getAllTagsForLists();
    return result;
  }

  var currentSearchQueryLocal = "";

  function searchQueryChanged(query, fromTags) {
    if (searchQueryInputRef.current === null) {
      return;
    }

    var localSwapper = selectedFilterTags;
    if (fromTags) {
      localSwapper = query;
    }

    var filteredByTags = [];
    if (localSwapper.length > 0) {
      for (var k = 0; k < listContent.length; k++) {
        const listid = listContent[k].listid;
        const tags = tagsToList[listid];
        if (tags !== null && typeof tags !== undefined && tags.length > 0) {
          var localMap = {};
          for (var q = 0; q < tags.length; q++) {
            localMap[tags[q].tagid] = 1;
          }

          for (var q = 0; q < localSwapper.length; q++) {
            const filterResult = localMap[localSwapper[q].tagid];
            if (filterResult !== null && typeof filterResult !== "undefined") {
              filteredByTags.push(listContent[k]);
              break;
            }
          }
        } else {
          // tags not available for this list
        }
      }
    } else {
      filteredByTags = listContent;
    }

    currentSearchQueryLocal = searchQueryInputRef.current.value.trim();
    if (currentSearchQueryLocal === "") {
      setFilteredListContent(filteredByTags);
      return;
    }

    setTimeout(function() {
      const lowerCaseQuery = currentSearchQueryLocal.toLowerCase();
      var newList = [];
      for (var k = 0; k < filteredByTags.length; k++) {
        const list = filteredByTags[k];
        const name = list.name !== null ? list.name : "";
        if (name.toLowerCase().indexOf(lowerCaseQuery) !== -1) {
          newList.push(list);
        }
      }
      setFilteredListContent(newList);
    }, 0);
  }

  function focused() {
    setFocus(true);
  }

  function notFocused() {
    setFocus(false);
  }

  async function tagTermFilterUpdated(richSelection) {
    setSelectedFilterTags(richSelection);
    searchQueryChanged(richSelection, true);
  }

  return (
    <div className="active lists">
      <div className="lists-card-search">
        <div className="list-card-search-content">
          <InputGroup className="mb-3 list-searchbar">
            <InputGroup.Prepend>
              {/* <InputGroup.Text id="basic-addon1">Search</InputGroup.Text> */}
            </InputGroup.Prepend>
            <Form.Control
              ref={searchQueryInputRef}
              placeholder="Search lists..."
              onFocus={focused}
              onBlur={notFocused}
              onChange={searchQueryChanged}
            />
          </InputGroup>
          <ListTagsTypeahead
            className="list-tags-typeahead"
            email={props.email}
            organizationid={props.organizationid}
            currentListCallback={props.currentListCallback}
            ref={listTagsTypeaheadRef}
            isSearchMode={true}
            tagTermFilterUpdated={tagTermFilterUpdated}
          />
        </div>
      </div>
      <div className="list-cards-wrapper">
        <div className="list-cards">
          <div
            className="list-card add-card"
            onClick={props.createNewListAction}
          >
            <p>
              +<br></br>Create New Event
            </p>
          </div>
          {handleListFetch(filteredListContent)}
        </div>
      </div>
      {/* <button
        type="button"
        className="btn btn-primary create-list-button"
        onClick={props.createNewListAction}
      >
        Create List
      </button>
      <Button variant="outline-secondary" onClick={props.showUploadListModal}>
        Upload CSV
      </Button> */}
    </div>
  );
}
